import { FC, memo, useRef } from 'react'

import { useAutoSizeTextArea } from '@/lib/hooks/useAutoSizeTextArea'

interface TextAreaProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  placeholder: string
  className: string
  maxLength?: number
}

const TextAreaComponent: FC<TextAreaProps> = ({
  value,
  onChange,
  placeholder,
  className,
  maxLength = 1200,
}) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  useAutoSizeTextArea(textAreaRef.current, value)

  return (
    <textarea
      ref={textAreaRef}
      onChange={onChange}
      maxLength={maxLength}
      rows={1}
      className={className}
      placeholder={placeholder}
    />
  )
}

export const TextArea = memo(TextAreaComponent)
